import Preloader from "../component/Preloader";
import Header from "../component/Header";
import LanguagePopup from "../component/LanguagePopup";
import HomeContent from "../component/HomeContent";
import Footer from "../component/Footer";
import FloatingWidgets from "../component/FloatingWidgets";
import HomeModals from "../component/HomeModals";
import useHomeInteractions from "../component/useHomeInteractions";
import ReactCarouselRuntime from "../component/ReactCarouselRuntime";

export default function Home({ optionTwo = false }) {
  const interactions = useHomeInteractions();

  return (
    <>
      <Preloader />
      <Header />
      <LanguagePopup />
      <ReactCarouselRuntime />
      <HomeContent {...interactions} optionTwo={optionTwo} />
      <Footer />
      <FloatingWidgets {...interactions} />
      <HomeModals {...interactions} />
    </>
  );
}
